import { track } from 'stash/hooks/useTrack';
import { ROTH_IRA, TRADITIONAL_IRA } from 'stash/constants/accountTypes';
import { v1_AccountSetup_Clicked } from '@stashinvest/product-events-javascript/lib/v1/event_static_methods';
import {
	AccountType,
	FlowType,
	ManagementType,
	Origin,
	Screen,
} from '@stashinvest/product-events-javascript/lib/enum_properties';

export function trackAccountSetup_Clicked(accountType) {
	const mapProductType = {
		[ROTH_IRA]: AccountType.rothIra,
		[TRADITIONAL_IRA]: AccountType.traditionalIra,
	};

	track(
		v1_AccountSetup_Clicked({
			account_type: mapProductType[accountType],
			flow_type: FlowType.new, //'new', 'incomplete', 'upgradeTier'
			management_type: ManagementType.selfDirected,
			origin: Origin.mystash,
			screen: Screen.iraTypeSelection,
		})
	);
}
